module.exports = __webpack_public_path__ + "media/images/normas-ba_icon_72-89e80a869473810ca826c79c6b482bbe.png";